import type { ReactNode } from 'react'
import { AlertCircle } from 'lucide-react'
import { isSessionExpiredMessage, SessionExpiredAction } from '../../../components/ui/SessionExpiredAction'

/** Поле ввода форм раздела аналитики: одинаковый вид в модалках, тёмная тема на zinc. */
export const INPUT_CLASS =
  'block h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-900 shadow-sm ' +
  'focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-60 ' +
  'dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-100'

/** Подписанное поле формы. */
export function Field({
  label,
  hint,
  className,
  children,
}: {
  label: string
  hint?: string
  className?: string
  children: ReactNode
}) {
  return (
    <label className={`block ${className ?? ''}`}>
      <span className="mb-1 block text-sm font-medium text-gray-700 dark:text-zinc-300">{label}</span>
      {children}
      {hint && <span className="mt-1 block text-xs text-gray-500 dark:text-zinc-400">{hint}</span>}
    </label>
  )
}

/** Сообщение об ошибке над содержимым или под формой. */
export function ErrorNotice({ messages }: { messages: string[] }) {
  if (messages.length === 0) return null
  return (
    <div
      role="alert"
      className="flex items-start gap-2 rounded-lg bg-red-50 p-3 text-sm text-red-700 dark:bg-red-950/40 dark:text-red-400"
    >
      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <ul className="space-y-0.5">
        {messages.map((message) => (
          <li key={message}>{message}</li>
        ))}
      </ul>
      {messages.some(isSessionExpiredMessage) && <SessionExpiredAction className="ml-auto shrink-0" />}
    </div>
  )
}
